import React from "react";
import { Box, Flex, Text, Spinner, Portal } from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { NewTabIcon } from "@root/assets/icons/NewTabIcon";
import { PDF_LOADING_ACTION } from "@root/constants";

interface SourceContextMenuProps {
  menuPosition: { x: number; y: number } | null;
  selectedSourceItem: any;
  loadingAction: PDF_LOADING_ACTION | null;
  onOpenInNewTab: () => void;
  onViewCitedText: () => void;
  onClose: () => void;
}

export const SourceContextMenu: React.FC<SourceContextMenuProps> = ({
  menuPosition,
  selectedSourceItem,
  loadingAction,
  onOpenInNewTab,
  onViewCitedText,
  onClose,
}) => {
  const { t } = useTranslation("common");

  if (!menuPosition || !selectedSourceItem) {
    return null;
  }

  return (
    <Portal>
      <Box
        position="fixed"
        top={menuPosition.y}
        left={menuPosition.x}
        zIndex={9999}
        bg="white"
        border="1px solid #E2E8F0"
        borderRadius="8px"
        boxShadow="lg"
        width="200px"
        py={1}
        onClick={(e) => e.stopPropagation()}
      >
        <Flex
          as="button"
          w="100%"
          alignItems="center"
          gap={2}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onOpenInNewTab();
          }}
          fontSize="13px"
          px={3}
          py={2}
          _hover={loadingAction ? {} : { bg: "#F7F9FC" }}
          cursor={loadingAction ? "not-allowed" : "pointer"}
          color={loadingAction ? "#9CA3AF" : "#1A202C"}
          textAlign="left"
          disabled={!!loadingAction}
          opacity={loadingAction ? 0.6 : 1}
        >
          {loadingAction === PDF_LOADING_ACTION.NEW_TAB ? (
            <Spinner size="sm" color="#005EB8" boxSize="14px" />
          ) : (
            <NewTabIcon size={16} color="#005EB8" />
          )}
          <Text fontSize="13px" fontWeight="400" mt={"3px"}>
            {t("assessments.openInNewTab")}
          </Text>
        </Flex>
        <Flex
          as="button"
          w="100%"
          alignItems="center"
          gap={2}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onViewCitedText();
          }}
          fontSize="13px"
          px={3}
          py={2}
          _hover={loadingAction ? {} : { bg: "#F7F9FC" }}
          cursor={loadingAction ? "not-allowed" : "pointer"}
          color={loadingAction ? "#9CA3AF" : "#1A202C"}
          textAlign="left"
          disabled={!!loadingAction}
          opacity={loadingAction ? 0.6 : 1}
        >
          <ViewIcon boxSize="12px" width="13px" height="13px" color="#005EB8" />
          <Text fontSize="13px" fontWeight="400">
            {t("legalCompliance.viewCitedText")}
          </Text>
        </Flex>
      </Box>
    </Portal>
  );
};
